import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Legacy from "./sections/Legacy";
import Process from "./sections/Process";
import Leadership from "./sections/Leadership";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Legacy />
      <Process />
      <Leadership />
      <Footer />
    </div>;
}